import React from 'react';
import cls from './Option.module.css';
import classNames from 'classnames';
import { useGetSum } from '../../../../shared/hooks/useGetSum';

export const OptionBalance = ({ accountBalance }) => {
    const { float, kopecks } = useGetSum(accountBalance.current_balance);
    return (
        <span className={classNames(cls.balance)}>
            [ {float},<span className={classNames(cls.kopecks)}>{kopecks}</span>{' '}
            {accountBalance.sign} ]
        </span>
    );
};
